@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div class="dialog-header">
  <div class="mat-headline-5">{{site.name}} Members</div>
</div>

<div class="dialog-content">
  @if (initialized) {
    @if (!projectAccounts.length) {
      <div class="mat-body-strong">
        Found no members to show
      </div>
    }
    @for (pa of projectAccounts; track pa) {
      <div>
        <mat-checkbox class="check-list"
          [disabled]="!('manage-account' | able: site)"
          [checked]="pa.checked"
          (change)="onChange(pa, $event.checked)">
          <div class="mat-subtitle-1">{{pa.name}}</div>
          <div class="mat-caption">{{pa.projectRole?.role_name}}</div>
        </mat-checkbox>
      </div>
    }
  }
</div>

<div class="dialog-footer form-actions">
  <button mat-flat-button color="accent" (click)="onClose(true)">Close</button>
</div>
